$(() => {
  const codeForm = $('#codeForm');
  const codeInputs = codeForm.find('.code-input');
  let autoContinue = !showCaptcha;

  resetForm();

  function codeInputsKeypressBlur(e) {
    if (e.which === 8) { // backspace
      const prevCodeContainer = $(this).parent().prev('.code-input-container');
      const prevCode = prevCodeContainer.find('.code-input');

      if (prevCode.length) {
        prevCode.val(null);
        prevCode.focus();
      }
    }

    if ($(this).val().length >= 1) {
      return e.preventDefault();
    }

    $(this).val($(this).val().replace(/[^\d].+/, ''));
    if ((e.which < 48 || e.which > 57)) {
      event.preventDefault();
    }
  }

  function codeInputsOnInput(e) {
    e.preventDefault();
    const val = $(this).val();
    const nextCodeContainer = $(this).parent().next('.code-input-container');

    if (val.length) {
      let nextCode = null;
      if (val.length > 1) {
        let currentCode = $(this);

        for (let i = 0; i < val.length; i++) {
          currentCode.val(val[i]);
          nextCode = nextCodeContainer.find('.code-input');

          if (nextCode.length) {
            nextCode.focus();
            currentCode = nextCode;
          } else if (autoContinue) {
            submitForm();
          } else if (showCaptcha) {
            $('input[name="captcha[input]"]').focus();
          }
        }

        e.preventDefault();
      } else {
        nextCode = nextCodeContainer.find('.code-input');

        if (nextCode.length) {
          nextCode.focus();
        } else if (autoContinue) {
          submitForm();
        } else if (showCaptcha) {
          $('input[name="captcha[input]"]').focus();
        }
      }
    }
  }

  function submitForm() {
    let codeVal = '';
    codeForm.find('.code-input').each((i, el) => {
      codeVal += $(el).val();
    });

    codeForm.find('input[name=token]').val(codeVal);

    codeForm.submit();

    codeForm.fadeOut();
    $('.loader').fadeIn();
  }

  function handleCodeSuccess() {
    $('.loader-flex').css('display', 'flex');
    $('.loader').fadeOut();
    $('.loader-error').hide();
    $('.heading-normal').hide();
    $('.heading-success').show();

    $('.loader-success').fadeIn();

    setTimeout(redirectAfterSuccess, 2000);
  }

  function handleCodeError(data) {
    $('.loader-flex').css('display', 'flex');
    $('.loader').fadeOut();
    $('.heading-error').show();
    $('.heading-normal').hide();
    $('.heading-success').hide();

    if (data.showMsg) {
      $('#error').html(data.msg);
    } else {
      $('#error').html('Code is wrong or expired');
    }

    $('.loader-error').fadeIn();

    if (data.showCaptcha) {
      autoContinue = false;
      showCaptcha = true;
      $('.row.captcha').fadeIn();
    } else {
      autoContinue = true;
      showCaptcha = false;
      $('.row.captcha').fadeOut();
    }
  }

  function errorSkip() {
    $('.heading-error').hide();
    $('.heading-success').hide();
    $('.heading-normal').show();
    $('.loader-error').fadeOut();

    resetForm();
  }

  function resetForm() {
    codeForm.fadeIn();
    codeForm.find('.code-input').val(null);
    codeForm.find('.code-input')[0].focus();
  }

  function redirectAfterSuccess() {
    window.location = '/account/create';
  }

  function submitClick(e) {
    e.preventDefault();

    submitForm();
  }

  codeForm.ajaxForm({
    type: 'POST',
    url: checkCodeUrl,
    data: { format: 'json' },
    dataType: 'json',
    complete(xhr) {
      const data = jQuery.parseJSON(xhr.responseText);

      setTimeout(() => {
        if (data.error !== 1) {
          handleCodeSuccess(data);
        } else {
          handleCodeError(data);
        }
      }, 1000);
    }
  });


  $('.btn-try-again').click(errorSkip);
  $('.btn-redirect').click(redirectAfterSuccess);
  $('.btn-submit').click(submitClick);

  codeInputs.on('keypress keyup blur', codeInputsKeypressBlur);
  codeInputs.on('input', codeInputsOnInput);
});
